import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {OrderPeriod} from '../../graphql/graphql';
import { FormBuilder, FormControl } from '@angular/forms';


@Component({
  selector: 'app-order-period',
  templateUrl: './order-period.component.html',
  styleUrls: ['./order-period.component.scss']
})
export class OrderPeriodComponent implements OnInit {
  period$: OrderPeriod;
  periodForm;
  isIndefinite = new FormControl(false);
  isError = false;
  periodIndex;

  @Input()
  set period(value: any) {
    this.period$ = value.period;
    if (this.periodIndex === undefined) {
      this.periodIndex = value.index;
    }
    this.onPeriodError(!this.period$.dateTo);
    this.isIndefinite.valueChanges.subscribe(change => {
      this.period$.longTerm = change;
      if (!this.period$.dateTo) {
        this.onPeriodError(!change);
      }
      this.changeIsIndefinite.emit(change);
    });
    this.isIndefinite.setValue(value.period.longTerm);
    this.initForm(value.period);
  }
  @Input() periodsCount: number;

  @Input() disabled = false;

  get period() { return this.period$; }

  @Output() removed = new EventEmitter<any>();
  @Output() change = new EventEmitter<boolean>();
  @Output() hasError = new EventEmitter<any>();
  @Output() changeIsIndefinite = new EventEmitter<boolean>();

  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    if (! this.periodForm) {
      this.initForm();
    }
  }

  onClose() {
    this.onPeriodError(!this.period$.dateTo && !this.isIndefinite.value);
  }

  onPeriodError(condition) {
    if (condition) {
      this.isError = true;
      this.hasError.emit({ index: this.periodIndex, isError: true });
    } else {
      this.isError = false;
      this.hasError.emit({ index: this.periodIndex, isError: false });
    }
  }

  private initForm(value?: OrderPeriod) {
  //   if (value) {
  //     this.periodForm = this.fb.group({
  //       dateFrom: value.dateFrom || '',
  //       dateTo: value.dateTo || '',
  //       demand: value.demand || 0
  //     });
  //   } else {
  //     this.periodForm = this.fb.group({
  //       dateFrom:  '',
  //       dateTo: '',
  //       demand:  0
  //     });
  //   }
  //
  }

  remove() {
    this.removed.emit({ action: true, index: this.periodIndex });
  }

  demandInputControl(input) {
    const regex = /[0-9]/;
    if (!regex.test(input.key)) {
      input.preventDefault();
    }
    this.change.emit();
  }
}
